import React, { useEffect, useState } from "react";
import SideBar from "../master/SideBar";
import NavBar from "../master/NavBar";
import { LoadingDiv } from "../../pages/master/Master";
import { AdminFinanceReport, AdminBranchList } from "../../api/AdminService";

import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend,
} from "recharts";

export default function FinanceReport() {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [branches, setBranches] = useState([]);

    const [filters, setFilters] = useState({
        branch_id: "",
    });

    const getReport = async () => {

        try {

            setLoading(true);

            let url = "";

            Object.entries(filters).forEach(([key, value]) => {

                if (value) {
                    url += `${key}=${value}&`;
                }

            });

            const response = await AdminFinanceReport(url);

            if (response.data.status) {
                setData(response.data.data || {});
            }

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);
        }
    };

    const getBranches = async () => {

        try {

            const response = await AdminBranchList();

            if (response.data.status) {
                setBranches(response.data.data || []);
            }

        } catch (error) {

            console.log(error);

        }
    };

    useEffect(() => {

        getReport();
        getBranches();

    }, [filters]);

    const feeModuleGraph = [
        {
            name: "Registration",
            total: Number(data?.registration_fee?.total || 0),
            paid: Number(data?.registration_fee?.paid || 0),
            pending: Number(data?.registration_fee?.pending || 0),
        },
        {
            name: "Tuition",
            total: Number(data?.tuition_fee?.total || 0),
            paid: Number(data?.tuition_fee?.paid || 0),
            pending: Number(data?.tuition_fee?.pending || 0),
        },
        {
            name: "Transport",
            total: Number(data?.bus_fee?.total || 0),
            paid: Number(data?.bus_fee?.paid || 0),
            pending: Number(data?.bus_fee?.pending || 0),
        },
    ];

    return (
        <>
            {loading && <LoadingDiv />}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">

                    <SideBar />

                    <div className="layout-page">

                        <NavBar />

                        <div className="content-wrapper">

                            <div className="container-fluid p-4">

                                {/* Header */}

                                <div className="card p-3 mb-3 shadow-sm border-0">
                                    <div className="d-flex justify-content-between align-items-center">

                                        <div className="d-flex align-items-center gap-3">

                                            <div
                                                style={{
                                                    width: 45,
                                                    height: 45,
                                                    borderRadius: 12,
                                                    background:
                                                        "linear-gradient(45deg,#198754,#20c997)",
                                                    color: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <i className="ri-money-rupee-circle-line"></i>
                                            </div>

                                            <div>
                                                <h5 className="m-0 fw-bold">
                                                    Finance Reports
                                                </h5>

                                                <small className="text-muted">
                                                    Collection & Fee Analytics
                                                </small>
                                            </div>

                                        </div>

                                        <div className="form-floating form-floating-outline">

                                            <select
                                                className="form-select"
                                                value={filters.branch_id}
                                                onChange={(e) =>
                                                    setFilters({
                                                        ...filters,
                                                        branch_id: e.target.value,
                                                    })
                                                }
                                            >
                                                <option value="">
                                                    All Branches
                                                </option>

                                                {branches?.map((branch) => (
                                                    <option
                                                        key={branch.id}
                                                        value={branch.id}
                                                    >
                                                        {branch.name}
                                                    </option>
                                                ))}
                                            </select>

                                            <label>Branch</label>

                                        </div>

                                    </div>
                                </div>

                                {/* Summary */}

                                <div className="row g-3">

                                    <div className="col-md-3">
                                        <div className="simple-card border-primary">
                                            <small>Total Students</small>
                                            <h4>
                                                {data?.fees_summary?.students || 0}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-success">
                                            <small>Total Fees</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.fees_summary?.total_fees || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-info">
                                            <small>Collected Fees</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.fees_summary?.collected_fees || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-danger">
                                            <small>Pending Fees</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.fees_summary?.pending_fees || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                </div>

                                {/* Collection */}

                                <div className="row g-3 mt-2">

                                    <div className="col-md-3">
                                        <div className="simple-card border-success">
                                            <small>Today Collection</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.collection?.today_collection || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-warning">
                                            <small>Yesterday Collection</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.collection?.yesterday_collection || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-info">
                                            <small>This Week</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.collection?.week_collection || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="simple-card border-primary">
                                            <small>This Month</small>
                                            <h4>
                                                ₹ {Number(
                                                    data?.collection?.month_collection || 0
                                                ).toLocaleString("en-IN")}
                                            </h4>
                                        </div>
                                    </div>

                                </div>

                                {/* Graphs */}

                                <div className="row mt-4 g-4">

                                    <div className="col-lg-6">

                                        <div className="card">

                                            <div className="card-header">
                                                <h5 className="mb-0">
                                                    Collection Analytics
                                                </h5>
                                            </div>

                                            <div className="card-body">

                                                <ResponsiveContainer
                                                    width="100%"
                                                    height={350}
                                                >
                                                    <BarChart
                                                        data={
                                                            data?.collection_graph || []
                                                        }
                                                    >
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis />
                                                        <Tooltip
                                                            cursor={{ fill: "transparent" }}
                                                        />
                                                        <Bar
                                                            dataKey="amount"
                                                            fill="#198754"
                                                            barSize={40}
                                                            radius={[6, 6, 0, 0]}
                                                            barSize={40}
                                                        />
                                                    </BarChart>
                                                </ResponsiveContainer>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="col-lg-6">

                                        <div className="card">

                                            <div className="card-header">
                                                <h5 className="mb-0">
                                                    Fee Module Analytics
                                                </h5>
                                            </div>

                                            <div className="card-body">

                                                <ResponsiveContainer
                                                    width="100%"
                                                    height={350}
                                                >
                                                    <BarChart data={feeModuleGraph}>
                                                        <CartesianGrid strokeDasharray="3 3" />
                                                        <XAxis dataKey="name" />
                                                        <YAxis
                                                            tickFormatter={(value) => {
                                                                if (value >= 10000000) return `${(value / 10000000).toFixed(1)}Cr`;
                                                                if (value >= 100000) return `${(value / 100000).toFixed(1)}L`;
                                                                return value;
                                                            }}
                                                        />
                                                        <Tooltip
                                                            cursor={{ fill: "transparent" }}
                                                        />
                                                        <Legend />

                                                        <Bar dataKey="total" fill="#0d6efd" barSize={30} />
                                                        <Bar dataKey="paid" fill="#198754" barSize={30} />
                                                        <Bar dataKey="pending" fill="#dc3545" barSize={30} />

                                                    </BarChart>
                                                </ResponsiveContainer>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                {/* Fee Summary */}

                                <div className="card mt-4">

                                    <div className="card-header">
                                        <h5 className="mb-0">
                                            Fee Module Summary
                                        </h5>
                                    </div>

                                    <div className="table-responsive">

                                        <table className="table table-bordered">

                                            <thead>

                                                <tr>
                                                    <th>Module</th>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>Pending</th>
                                                    <th>Discount</th>
                                                </tr>

                                            </thead>

                                            <tbody>

                                                <tr>
                                                    <td>Registration Fee</td>
                                                    <td>₹ {Number(data?.registration_fee?.total || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.registration_fee?.paid || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.registration_fee?.pending || 0).toLocaleString("en-IN")}</td>
                                                    <td>-</td>
                                                </tr>

                                                <tr>
                                                    <td>Tuition Fee</td>
                                                    <td>₹ {Number(data?.tuition_fee?.total || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.tuition_fee?.paid || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.tuition_fee?.pending || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.tuition_fee?.discount || 0).toLocaleString("en-IN")}</td>
                                                </tr>

                                                <tr>
                                                    <td>Transport Fee</td>
                                                    <td>₹ {Number(data?.bus_fee?.total || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.bus_fee?.paid || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.bus_fee?.pending || 0).toLocaleString("en-IN")}</td>
                                                    <td>₹ {Number(data?.bus_fee?.discount || 0).toLocaleString("en-IN")}</td>
                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </>
    );
}